import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_vintage_halloween: FaireCollectionEntity = {
  token: "col_vintage-halloween",
  type: "collection",
  name: "Vintage Halloween",
  description: "Nostalgic spooky season favorites.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1509557965875-b88c97052f0e?w=400&h=400&fit=crop",
  heroImageUrl:
    "https://images.unsplash.com/photo-1509557965875-b88c97052f0e?w=1200&h=600&fit=crop",
  season: "fall",
  itemCount: 31,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
